import { useMutation, useQueryClient } from '@tanstack/react-query';
import { generateGroupInfoQueryOptions } from '@/hooks/groups/use-group-info';
import type { RespondedType, ResponseError } from '@/models/response';
import { useMessageStore } from '@/stores/message';
import { addToast } from '@/stores/toast';
import { fetcher } from '@/utils/fetcher';

export default function useKickGroupMember(groupId: Nullable<number>) {
  const queryClient = useQueryClient();

  return useMutation<RespondedType, ResponseError, KickOutGroupMemberRequest>({
    mutationKey: ['/KickOutGroup', groupId],
    mutationFn: (params) =>
      fetcher(
        '/KickOutGroup',
        {
          GroupID: groupId,
          UserID: params.userId,
          DeleteAllChat: params.purgeMessages,
        },
        { validResponseCodes: [0] },
      ),
    onSuccess: async (_, params) => {
      if (groupId) {
        await queryClient.refetchQueries(generateGroupInfoQueryOptions(groupId));
        if (params.purgeMessages) {
          await useMessageStore.getState().deleteByUserId(params.userId, 'group', groupId);
        }
      }
    },
    onSettled: (data, error) =>
      addToast({
        type: data ? 'success' : 'error',
        message: data?.Msg ?? error?.message,
      }),
  });
}

type KickOutGroupMemberRequest = {
  userId: number;
  purgeMessages: boolean;
};
